import { useNavigate,useLocation } from "react-router-dom"
import { useEffect } from "react"
import { url,reemplazarAcentos } from "../Funciones"
export default function EnlacesGRP({enlaces,enlaces_en}){
    const idioma=localStorage.getItem("idioma") || "es"
    const location=useLocation()
    const navigate=useNavigate()
    useEffect(()=>{
        if (reemplazarAcentos(location.pathname)=="/grp/"+url(enlaces[0])){
            navigate("/grp")
        }
    })
    let elements=Array.from({length:enlaces.length},(_,i)=>(
        <a key={i} href={'/grp/'+url(enlaces[i])} className={reemplazarAcentos(location.pathname).includes("/grp/"+url(enlaces[i])) || (i==0 && location.pathname.replace("/grp","").length<=1) ?'active-link':'link'} style={{color:'white'}}>{idioma=="en"?enlaces_en[i].toUpperCase():enlaces[i].toUpperCase()}</a>
    ))
    return(
        <div className="grp-links">
            {elements}
        </div>
    )
}